import EducatorAdminExperiments from 'bundles/epic/clients/EducatorAdmin';

export const redesignStaffManagement = () => {
  return EducatorAdminExperiments.get('enableAcceleratedPlatformAccessForContentCreators');
};
